import { render, staticRenderFns } from "./groupList.vue?vue&type=template&id=578cd8cd&scoped=true"
import script from "./groupList.vue?vue&type=script&lang=js"
export * from "./groupList.vue?vue&type=script&lang=js"
import style0 from "./groupList.vue?vue&type=style&index=0&id=578cd8cd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578cd8cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('578cd8cd')) {
      api.createRecord('578cd8cd', component.options)
    } else {
      api.reload('578cd8cd', component.options)
    }
    module.hot.accept("./groupList.vue?vue&type=template&id=578cd8cd&scoped=true", function () {
      api.rerender('578cd8cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/spellGroup/goodsList/components/groupList.vue"
export default component.exports